import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { latestComics } from '@/mocks/comics';

export default function LatestUpdatesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              每日更新的韩漫最新章节
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-1">
            <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-background-50 text-foreground-700 border border-background-200/70 hover:border-background-300/70 transition-colors cursor-pointer whitespace-nowrap">
              最新
            </button>
            <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
              最热
            </button>
            <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
              评分
            </button>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>

        {/* Mobile sort */}
        <div className="mt-6 flex items-center justify-center gap-1 sm:hidden">
          <button className="px-3 py-1.5 text-xs font-medium rounded-full bg-background-50 text-foreground-700 border border-background-200/70 whitespace-nowrap cursor-pointer">
            最新
          </button>
          <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-500 whitespace-nowrap cursor-pointer">
            最热
          </button>
          <button className="px-3 py-1.5 text-xs font-medium rounded-full text-foreground-500 whitespace-nowrap cursor-pointer">
            评分
          </button>
        </div>
      </div>
    </section>
  );
}